import React, { Component } from "react";
import Helmet from "react-helmet";
import About from "../components/StartUp/StartUp";
import config from "../../data/SiteConfig";
import Header from "../components/Header/Header";
import SocialLinks from "../components/SocialLinks/SocialLinks";
import SEO from "../components/SEO/SEO";
import HeaderPage from "../components/Header/HeaderPageFull";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer/Footer";
import ToTopButton from "../components/ToTopButton/ToTopButton";
import Contact from "../components/Contact/Contact";
import picture from "../components/StartUp/img/start-up.jpg";

class StartUpPage extends Component {
  render() {
    const { slug } = this.props.pathContext;
    const postNode = {
        "frontmatter": {
            "title": "L'agence Web et mobile des entrepreneurs",
            "description":  "Partenaires techniques pour les projets innovants des start-up. Analyse, conseil et réalisation des applications sur-mesure.",
            "cover": picture
        }
    };

    let title = "L'agence Web et mobile des entrepreneurs";
    let description = "L'innovation technologique au service de vos idées";
    let goto = "En savoir plus";

    return (
      <div className="about" id="outer-container">
        <Helmet title={title} />
        <SEO postPath={slug} postNode={postNode} postSEO />
        <Menu/>
            <div id="page-wrap">
              <main id="fh5co-about">
                <Header />
                <HeaderPage title={title} description={description}  picture={picture} />
                <About />
                <Contact />
              </main>
              <Footer/>
              
              <ToTopButton/>
            </div>
      </div>
    );
  }
}

export default StartUpPage;



// WEBPACK FOOTER //
// ./src/pages/startup.jsx